const runHtml = require("./runHtml");

/**
 * @param emailId {string}
 * @return {HTMLInputElement}
 */
module.exports = function runCreateIterableEmailIdInput(emailId) {
  return runHtml(
    `<input type="hidden" style="display: none;" aria-hidden="true" name="Iterable_Email_ID__c" value="${emailId}">`,
  );
};
